// import { InputSelect } from "#common/componentes/Inputs"
import { MasterDialog } from "#common/Dialog/Dialog"
import { UseContextsQuestion } from "#competence/contexts/ContextsQuestion"
import { QuestionDelete } from "#competence/services/Api"
import { useApiSend } from "#hooks/useApiSend"
import { Stack, Typography } from "@mui/material"
import { Fragment, useMemo, useState } from "react"

export default function CompetenceQuestionDelete() {
	const { open, setOpen, question, refresh } = UseContextsQuestion()
	const [disabled, setDisabled] = useState(false)
	const [disabledCancelar, setDisabledCancelar] = useState(false)

	const success = () => {
		refresh()
		setOpen(false)
	}

	const end = () => {
		setDisabled(false)
		setDisabledCancelar(false)
	}
	const { fetch } = useApiSend(QuestionDelete, { success, end })

	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
				},
				disabled: disabledCancelar,
			},
			{
				label: "Confirmar",
				onClick: () => {
					setDisabled(true)
					setDisabledCancelar(true)
					fetch(question?.id)
				},
				disabled,
			},
		]
	}, [disabled, disabledCancelar, fetch, question?.id, setOpen])

	return (
		<Fragment>
			<MasterDialog
				{...{
					open: open === "delete",
					setOpen,
					title: `Desactivar Pregunta ${question?.type_name}`,
					buttons,
				}}
				maxWidth="sm"
			>
				<Stack spacing={2} sx={{ width: "100%" }}>
					<Typography variant="h5" textAlign="center">
						¿Estás seguro de que deseas desactivar la pregunta{" "}
						<strong>"{question?.question}"</strong>?
					</Typography>
				</Stack>
			</MasterDialog>
		</Fragment>
	)
}
